enum PaymentConstants {
  GET_PAYMENTS_REQUEST = "GET_PAYMENTS_REQUEST",
  GET_PAYMENTS_SUCCESS = "GET_PAYMENTS_SUCCESS",
  GET_PAYMENTS_FAILURE = "GET_PAYMENTS_FAILURE",

  GET_PAYMENT_DETAILS_REQUEST = "GET_PAYMENT_DETAILS_REQUEST",
  GET_PAYMENT_DETAILS_SUCCESS = "GET_PAYMENT_DETAILS_SUCCESS",
  GET_PAYMENT_DETAILS_FAILURE = "GET_PAYMENT_DETAILS_FAILURE",

  CREATE_PAYMENT_REQUEST = "CREATE_PAYMENT_REQUEST",
  CREATE_PAYMENT_SUCCESS = "CREATE_PAYMENT_SUCCESS",
  CREATE_PAYMENT_FAILURE = "CREATE_PAYMENT_FAILURE",

  UPDATE_PAYMENT_REQUEST = "UPDATE_PAYMENT_REQUEST",
  UPDATE_PAYMENT_SUCCESS = "UPDATE_PAYMENT_SUCCESS",
  UPDATE_PAYMENT_FAILURE = "UPDATE_PAYMENT_FAILURE",

  RESET_PAYMENTS = "RESET_PAYMENTS",
}

export default PaymentConstants;
